export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

// Generate login URL at runtime so redirect URI reflects the current origin.
export const getLoginUrl = () => {
  const oauthPortalUrl = import.meta.env.VITE_OAUTH_PORTAL_URL;
  if (!oauthPortalUrl) {
    return "/login";
  }
  try {
    const appId = import.meta.env.VITE_APP_ID || "";
    const redirectUri = typeof window !== "undefined" ? `${window.location.origin}/api/oauth/callback` : "";
    const state = btoa(redirectUri);

    const url = new URL(`${oauthPortalUrl}/app-auth`);
    url.searchParams.set("appId", appId);
    url.searchParams.set("redirectUri", redirectUri);
    url.searchParams.set("state", state);
    url.searchParams.set("type", "signIn");

    return url.toString();
  } catch (e) {
    return "/login";
  }
};

export const isBriqueziAnota = 
  typeof window !== "undefined" && 
  (window.location.hostname.includes("anota.briquezi") || window.location.port === "3010");

export const isBriqueziNet = 
  typeof window !== "undefined" && 
  (window.location.hostname.includes("briquezi.net.br") || window.location.hostname.includes("briquezi.com.br") || window.location.port === "3011");

export const isBriquezi = isBriqueziAnota || isBriqueziNet || (typeof window !== "undefined" && (window.location.hostname.includes("briquezi") || window.location.port === "3001"));

export const BRAND_NAME = isBriquezi ? "Briquezi Soluções" : "Só Facilitei";
